import type { ReactNode } from 'react';
import { LoadFailed } from '../../LoadFailed.tsx';
import { usePageContext } from '../../usePageContext.ts';

export type WidgetQuery = {
  readonly isError: boolean;
  readonly error: unknown;
  readonly isFetching: boolean;
  readonly refetch: () => Promise<unknown>;
};

export const WidgetBody = ({ query, children }: { query: WidgetQuery; children: ReactNode }) => {
  const { describeError } = usePageContext();
  if (query.isError)
    return (
      <LoadFailed
        description={describeError(query.error)}
        onRetry={() => {
          void query.refetch();
        }}
      />
    );
  return <div aria-busy={query.isFetching}>{children}</div>;
};
